import {Button, PatronThemeProvider} from "@unibuddy/patron";

export function HomeCustomButton({
    children,
    onClick,
}: {
    children: React.ReactNode;
    onClick: () => void;
}) {
    return (
        <PatronThemeProvider
            theme={{
                Button: {
                    colors: {
                        hideButtonCustom: {
                            bgColor: "transparent",
                            outlineColor: "white",
                            clearHoverBgColor: "rgba(255, 255, 255, 0.1)",
                            borderColor: "white",
                        },
                    },
                    heights: {
                        sm: "30px",
                    },
                },
            }}
        >
            <Button ghost color="hideButtonCustom" round size="sm" onClick={onClick}>
                {children}
            </Button>
        </PatronThemeProvider>
    );
}
